var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.hasCertificate
      ? _c("div", [
          _vm.ambit === _vm.ambits.profile
            ? _c("div", [
                _c("h3", [_vm._v("Firma Simple - Proveedor EDigital")]),
                _vm._m(0),
                _c("p", [
                  _vm._v(
                    " Comunícate con tu administrador de sistema para que te habilite tu certificado. "
                  )
                ])
              ])
            : _c(
                "div",
                [
                  _c("ActiveSignEDigital", {
                    attrs: { configurations: _vm.requestData, user: _vm.user },
                    on: { activate: _vm.activate }
                  })
                ],
                1
              )
        ])
      : _vm._e(),
    _vm.hasCertificate
      ? _c("div", [
          _c("div", { staticClass: "row justify-content-center mb-3" }, [
            _c("div", { staticClass: "col-lg-8 col-md-12" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("h4", { staticClass: "card-title" }, [
                    _vm._v("Certificado EDigital")
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("p", [
                        _c("strong", [_vm._v("Nombre:")]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.formData.cedulaNombre) +
                            " " +
                            _vm._s(_vm.formData.cedulaApellidos)
                        )
                      ]),
                      _c("p", [
                        _c("strong", [_vm._v("Correo:")]),
                        _vm._v(" " + _vm._s(_vm.formData.correoPersonal))
                      ]),
                      _c("p", [
                        _c("strong", [_vm._v("Tipo documento:")]),
                        _vm._v(" " + _vm._s(_vm.documentTypeLabel))
                      ]),
                      _c("p", [
                        _c("strong", [_vm._v("Número de serie:")]),
                        _vm._v(" " + _vm._s(_vm.formData.identityDocument))
                      ])
                    ]),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("p", [
                        _c("strong", [_vm._v("Género:")]),
                        _vm._v(" " + _vm._s(_vm.genderLabel))
                      ]),
                      _c("p", [
                        _c("strong", [_vm._v("Fecha nacimiento:")]),
                        _vm._v(" " + _vm._s(_vm.formData.cedulaFnacimiento))
                      ]),
                      _c("p", [
                        _c("strong", [_vm._v("Estado:")]),
                        _c(
                          "span",
                          {
                            class: _vm.formData.activa
                              ? "text-success"
                              : "text-danger"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formData.activa ? "Activa" : "Inactiva"
                                ) +
                                " "
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _vm.ambit === _vm.ambits.profile
            ? _c("div", [
                _c("div", { staticClass: "row justify-content-center" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-8" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "hashPassword" } }, [
                        _vm._v("Contraseña del certificado")
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.formData.hash,
                            expression: "formData.hash"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|min:6",
                            expression: "'required|min:6'"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "password",
                          id: "hashPassword",
                          name: "hashPassword",
                          placeholder: "Ingrese contraseña del certificado",
                          autocomplete: "off"
                        },
                        domProps: { value: _vm.formData.hash },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.formData, "hash", $event.target.value)
                          }
                        }
                      }),
                      _vm.formData.existeEdigital
                        ? _c("small", { staticClass: "form-text text-muted" }, [
                            _vm._v(
                              " Ingrese la misma contraseña que usa en EDigital. "
                            )
                          ])
                        : _vm._e(),
                      _vm.errors.has("hashPassword")
                        ? _c(
                            "small",
                            { staticClass: "form-text text-danger" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.errors.first("hashPassword")) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  ])
                ]),
                _c("div", { staticClass: "row justify-content-center mt-3" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-8 text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button", disabled: _vm.saving },
                        on: { click: _vm.savePassword }
                      },
                      [
                        _vm.saving
                          ? _c("b-spinner", {
                              attrs: { small: "", variant: "light" }
                            })
                          : _c("span", [_vm._v("Guardar contraseña")])
                      ],
                      1
                    )
                  ])
                ])
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(" Para comenzar a operar con "),
      _c("b", [_vm._v("Firma Simple")]),
      _vm._v(", primero debemos crearte un "),
      _c("b", [_vm._v("Certificado Digital")]),
      _vm._v(
        " con el proveedor EDigital. Es como tu firma en papel, pero ahora será electrónica y mucho más segura. "
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }